import styled from 'styled-components';
import { color, screen } from 'theme';

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

export const MenuPanel = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 400px;
  height: 100%;
  background-color: ${color('white')};
  z-index: 1001;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;

  @media (min-width: ${screen('md2')}) {
    display: none;
  }
`;

export const MenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const HeaderSubTitle = styled.p`
  font-family: 'Archivo Narrow', sans-serif;
  font-size: 19px;
  text-transform: uppercase;
  color: ${color('black')};
  margin: 0;
`;

export const HeaderLogo = styled.div`
  img {
    height: 35px;
    width: auto;
  }
`;

export const CloseButton = styled.button`
  background-color: #3053f9;
  color: ${color('white')};
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  /* cursor: pointer removed */
`;

export const MenuItems = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 16px;

  .menu-ticket-button {
    margin-top: 24px;
    max-width: 250px;
  }
`;

export const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* cursor: pointer removed */
  position: relative;
  height: 36px;
  width: fit-content;

  a {
    font-family: 'Archivo Narrow', sans-serif;
    font-weight: 500;
    font-size: 24px;
    text-transform: uppercase;
    color: #3053f9;
    line-height: 24px;
    text-decoration: none;
    white-space: nowrap;
  }

  .underline {
    display: none;
    flex-wrap: wrap;
    width: 100%;
    height: 8px;
    justify-content: center;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  &:hover {
    .underline {
      display: flex;
    }
  }
`;

export const Pixel = styled.div<{ color?: string; opacity?: number }>`
  width: 4px;
  height: 4px;
  background-color: ${({ color }) => color || '#3053f9'};
  opacity: ${({ opacity }) => (opacity !== undefined ? opacity : 1)};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: auto;
  padding-top: 32px;
  z-index: 1;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #becffe;
  width: 100%;
`;

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Copyright = styled.p`
  font-family: 'Archivo Narrow', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: ${color('black')};
  margin: 0;
`;

export const FooterLink = styled.a`
  font-family: 'Archivo Narrow', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #3053f9;
  text-decoration: none;
  /* cursor: pointer removed */

  &:hover {
    text-decoration: underline;
  }
`;

export const SocialMedia = styled.div`
  display: flex;
  gap: 16px;
`;

export const SocialIcon = styled.a`
  color: #3053f9;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  span,
  svg {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  path {
    width: 100%;
    height: 100%;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

export const DecorativeSquare = styled.div<{
  color: string;
  top?: string;
  left?: string;
  right?: string;
  width?: string;
}>`
  position: absolute;
  top: ${({ top }) => top || 'auto'};
  left: ${({ left }) => left || 'auto'};
  right: ${({ right }) => right || 'auto'};
  width: ${({ width }) => width || '50px'};
  height: 50px;
  background-color: ${({ color }) => color};
  pointer-events: none;
  z-index: -1;
`;
